import ElementSmallCard from './container';

export default ElementSmallCard;



// WEBPACK FOOTER //
// ./src/components/Cards/ElementSmallCard/index.js